<script lang="ts">
  import iconPic from './img/icon-pic.png'
  import iconDel from './img/icon-del.png'
  import { fade } from 'svelte/transition';
	export let avatar 
   let fileinput: HTMLInputElement
   let showWarning = false
	
	const onFileSelected = (e) =>{
    let image = e.target.files[0];
    if(!image) return
    if(image.size > 2 * 1024 * 1024) {
       showWarning = true
       setTimeout(() => {  
         showWarning = false
       }, 1500)
       return
    }
    let reader = new FileReader();
    reader.readAsDataURL(image);
    reader.onload = e => {
         avatar = e.target.result
    }; 
   }  
   const del = function():void {
      avatar = ''
    }

   let warnFlag = false
   let timer = null
   export function boxWarn():void  {
      clearTimeout(timer)
      warnFlag = true
      timer = setTimeout(() => {
         warnFlag = false
      }, 1500)
   }
</script>

<style lang="less" src="./Upload.less">
</style>


<div class="c-upload" transition:fade>
   {#if avatar}
      <img class="avatar" src="{avatar}" alt="d" on:click={()=>{fileinput.click();}}/>
      <div class="close" on:click={del}>
         <img src={iconDel} alt="" draggable={false}>
      </div>
      <div class="mask"></div>
   {:else}
      <div class="avatar" on:click={()=>{fileinput.click();}} style={`border-color: ${warnFlag ? '#db2e20': '#ccc' }`}>
        <img src={iconPic} alt="" class="avatar--default"/>
        <span class="avatar--tip">上传图片</span> 
      </div>
   {/if}
   {#if showWarning}
      <div class="warning" transition:fade>请上传不超过2M的图片！</div>
   {/if}
   <input style="display:none" type="file" accept="image/png,image/jpeg,image/jpg" on:change={(e)=>onFileSelected(e)} bind:this={fileinput} >
</div>

 